module.exports = __webpack_public_path__ + "img/advantage3.9867630f.png";